import React, { memo } from 'react';
import LatexComponent from 'components/HHQComponents/ViewMath';
import { QuestionType } from 'components/HHQComponents/common/constants';

import { TestDetailQuizModel } from 'models/test-detail.model';
import './index.css';
interface PropTypes {
    question: TestDetailQuizModel;
    showTruth: boolean;
}
const TCHCauHoiLuaChonComponent: React.FC<PropTypes> = ({ question, showTruth }) => {
  return (
    <div>
      {(question.testQuestionAnswers || []).map((answer, index) => {
        if (!Array.isArray(question.userAnswer)) {
          question.userAnswer = [];
        }

        const isChecked = question.userAnswer.includes(answer?.order);
        const shouldShowTruth = !isChecked && answer?.isCorrect === 1 && showTruth;

        return (
          <div
            key={`answer${question.id}-${index}`}
            className="question-content--item choose-question border-top-dashed-gray-200"
          >
            <div className="checkbox-group">
              <label
                className="custom-checkbox"
                htmlFor={`cb${question.id}${index}`}
              >
                <input
                  type={
                    question.testQuestionTypeCode === QuestionType.mot_lua_chon
                      ? 'radio'
                      : 'checkbox'
                  }
                  disabled
                  name={question.id || ''}
                  defaultChecked={isChecked}
                  value={answer?.answer}
                  className=""
                  id={`cb${question.id}${index}`}
                />

                <div>
                  <LatexComponent>
                    <span
                      className={
                        answer?.answer
                          ? 'text-bolder'
                          : 'text-bolder latex-component'
                      }
                      dangerouslySetInnerHTML={{ __html: answer?.answer || '' }}
                    />
                  </LatexComponent>

                  {answer?.comment && (
                    <div className="mt-2">
                      <div>- Gợi ý: </div>
                      <LatexComponent>
                        <div
                          dangerouslySetInnerHTML={{ __html: answer.comment }}
                        />
                      </LatexComponent>
                    </div>
                  )}

                  {shouldShowTruth && (
                    <small
                      className="result-truth checkbox text-bolder text-green-400"
                      title="Đáp án đúng"
                    >
                      <i className="pi pi-check-square font-size-22" />
                    </small>
                  )}
                </div>
              </label>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default memo(TCHCauHoiLuaChonComponent);
